import { render, staticRenderFns } from "./TechnicalDecisionPanel.vue?vue&type=template&id=8167f46a&scoped=true&"
import script from "./TechnicalDecisionPanel.vue?vue&type=script&lang=js&"
export * from "./TechnicalDecisionPanel.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalDecisionPanel.vue?vue&type=style&index=0&id=8167f46a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8167f46a",
  null
  
)

export default component.exports